import { render } from "./CommentModal.vue?vue&type=template&id=07189cd5"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"
script.render = render

export default script